import HomeView from '@/views/main/HomeView.vue'
import WatchView from '@/views/main/WatchView.vue'
import WatchNow from '@/views/main/WatchNow.vue'
import CategoriesView from '@/views/main/CategoriesView.vue'
import TermsView from '@/views/brows/TermsView.vue'

export const mainRoutes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      footer: true,
      auth: false

    }
  },
  {
    path: '/watch/:id',
    name: 'watch',
    component: WatchView,
    meta: {
      footer: true,
      auth: false,
      title: 'ناسنا | مننا ولينا',
      description: 'ناسنا | مننا ولينا',
    }
  },
  {
    path: '/watch/now/:id',
    name: 'watch.now',
    component: WatchNow,
    meta: {
      footer: true,
      auth: false,
      title: 'ناسنا | مننا ولينا',
      description: 'ناسنا | مننا ولينا',

    }
  },
  {
    path: '/categories',
    name: 'categories',
    component: CategoriesView,
    meta: {
      footer: true,
      auth: false,
      title: 'ناسنا | التصنيفات' ,

    }
  },
  {
    path: '/show/terms',
    name: 'terms',
    component: TermsView,
    meta: {
      footer: true,
      auth: false,
      title: 'ناسنا | التصنيفات' ,

    }
  }
]